import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableLeadFormList = Loadable({
  loader: function loader() {
    return import('../LeadFormList.jsx');
  },
  loading: ComponentLoading
});
export default LoadableLeadFormList;